export const dashboardLinks = {
  dashboardLink: () => '',
}
